export default __webpack_public_path__ + "static/media/seo.b323da63.png";